import { API } from "lib/API";
import { TAIImportSettings, TAIImportStatus, UpdateAIImportSettingsRequest } from "types";

export const getAIImportSettings = async (): Promise<TAIImportSettings> => {
  const { data } = await API.GET<{ data: TAIImportSettings }>("/company/ai-import-settings");
  return data;
};

export const updateAIImportSettings = async (
  request: UpdateAIImportSettingsRequest,
): Promise<TAIImportSettings> => {
  const { data } = await API.PUT<UpdateAIImportSettingsRequest, { data: TAIImportSettings }>(
    "/company/ai-import-settings",
    request,
  );
  return data;
};

export const deleteAIImportSettings = async (): Promise<TAIImportSettings> => {
  const { data } = await API.DELETE<{ data: TAIImportSettings }>("/company/ai-import-settings");
  return data;
};

export const getAIImportStatus = async (): Promise<TAIImportStatus> => {
  const { data } = await API.GET<{ data: TAIImportStatus }>("/company/ai-import-status");
  return data;
};
